/**
 * Curtain product builder.
 * Relies on ProductBuilderCart for payload + submit (unit-tested).
 * Buy button stays disabled/loading until this script finishes wiring.
 */
let CPB_C_BORDER_TEXT = "";
let CPB_C_TIEBACK_TEXT = "";
let CPB_C_BORDER_COLOR = "";
let CPB_C_TIEBACK_COLOR = "";
let CPB_C_SUBMIT_IN_FLIGHT = false;

document.addEventListener("DOMContentLoaded", () => {
    const customSection = document.querySelector(".cpb_c-section");
    if (!customSection) return;

    if (typeof CPB_C_FORMID === "undefined" || typeof CPB_C_SECTIONID === "undefined") {
        console.error("curtain builder: missing form/section ids");
        return;
    }

    if (typeof ProductBuilderCart === "undefined") {
        console.error("curtain builder: ProductBuilderCart missing — cart script failed to load");
        return;
    }

    const form = document.querySelector(`#${CPB_C_FORMID}`);
    if (!form) return;

    const addToCartButton = document.querySelector(`#ProductSubmitButton-${CPB_C_SECTIONID}`);
    if (!addToCartButton) return;

    // --------- initial color defaults (first swatch in each group) ---------
    customSection.querySelectorAll(".cpb_c-color-options").forEach((group) => {
        const first = group.querySelector(".cpb_c-color-option[data-color]");
        if (!first) return;
        const textType = group.dataset.textType;
        if (textType === "tieback") CPB_C_TIEBACK_COLOR = first.dataset.color || "";
        else if (textType === "border") CPB_C_BORDER_COLOR = first.dataset.color || "";
    });

    const popup = document.querySelector(".cpb_c-popup");

    // --------- text inputs ---------
    customSection.querySelectorAll("input[type='text']").forEach((input) => {
        input.value = "";
        input.addEventListener("input", (e) => {
            const value = e.target.value || "";
            const textType = input.dataset.textType;
            if (textType === "tieback") {
                CPB_C_TIEBACK_TEXT = value.length <= 12 ? value : value.slice(0, 12);
            } else if (textType === "border") {
                CPB_C_BORDER_TEXT = value.length <= 15 ? value : value.slice(0, 15);
            }
        });
    });

    // --------- image zoom (null-safe) ---------
    customSection.querySelector(".cpb_c-image")?.addEventListener("click", () => {
        if (popup) popup.style.display = "flex";
    });
    popup?.querySelector("svg")?.addEventListener("click", () => {
        popup.style.display = "none";
    });

    // --------- colors ---------
    customSection.querySelectorAll(".cpb_c-color-option").forEach((color) => {
        color.addEventListener("click", () => {
            const textType = color.parentElement?.dataset?.textType;
            const selectedValue = color.dataset.color;
            if (!selectedValue || !textType) return;

            if (textType === "tieback") CPB_C_TIEBACK_COLOR = selectedValue;
            else if (textType === "border") CPB_C_BORDER_COLOR = selectedValue;

            color.parentElement.querySelectorAll(".cpb_c-color-option").forEach((c) => {
                c.classList.remove("selected");
            });
            color.classList.add("selected");
        });
    });

    function setBusy(busy) {
        if (busy) {
            addToCartButton.classList.add("loading");
            addToCartButton.disabled = true;
            addToCartButton.querySelector(".loading__spinner")?.classList.remove("hidden");
        } else {
            addToCartButton.classList.remove("loading");
            addToCartButton.querySelector(".loading__spinner")?.classList.add("hidden");
            if (addToCartButton.dataset.disabled == null) {
                addToCartButton.disabled = false;
            }
        }
    }

    addToCartButton.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (CPB_C_SUBMIT_IN_FLIGHT) return;

        const mainProductId = form.querySelector("input[name='items[0][id]']")?.value;
        if (!mainProductId) {
            console.error("curtain builder: missing main variant id");
            return;
        }

        const orderNote = document.querySelector(`#tti-note-${CPB_C_SECTIONID}`);
        const truckBrand = document.querySelector("input[name='curtainTruckBrandInput']:checked");

        const built = ProductBuilderCart.buildCurtainCartItems({
            mainVariantId: mainProductId,
            groupHash: Math.random().toString(36).slice(2, 7),
            truckSelectorActive: !!CPB_C_TRUCK_SELECTOR_ACTIVE,
            truckBrand: truckBrand?.value || "",
            orderNote: orderNote?.value || "",
            borderText: CPB_C_BORDER_TEXT,
            borderColor: CPB_C_BORDER_COLOR,
            borderVariantId: typeof CPB_C_TEXT_LB_ID !== "undefined" ? CPB_C_TEXT_LB_ID : null,
            tiebackText: CPB_C_TIEBACK_TEXT,
            tiebackColor: CPB_C_TIEBACK_COLOR,
            tiebackVariantId: typeof CPB_C_TEXT_T_ID !== "undefined" ? CPB_C_TEXT_T_ID : null,
        });

        if (!built.ok) {
            if (built.reason === "missing_truck_brand") {
                document
                    .querySelector(".cpb_c-truck-selector, .cpb_c-section")
                    ?.scrollIntoView({ behavior: "smooth", block: "start" });
            } else if (
                built.reason === "missing_border_color" ||
                built.reason === "missing_border_variant"
            ) {
                document.querySelector("#cpb_c_writing1")?.scrollIntoView({ behavior: "smooth", block: "center" });
            } else if (
                built.reason === "missing_tieback_color" ||
                built.reason === "missing_tieback_variant"
            ) {
                document.querySelector("#cpb_c_writing2")?.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            return;
        }

        CPB_C_SUBMIT_IN_FLIGHT = true;
        setBusy(true);

        const result = await ProductBuilderCart.submitCartAdd(built.items, mainProductId);
        if (!result.ok) {
            console.error("curtain builder add-to-cart failed:", result.reason, result.error);
        }

        CPB_C_SUBMIT_IN_FLIGHT = false;
        setBusy(false);
    });

    // Ready: handlers wired — lift the loading/disabled race gate
    setBusy(false);
});
